import { Breadcrumb } from 'antd';
import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function BreadcrumbWrapper() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };
  const items = [
    // {
    //   title: <Link to="/">Home</Link>
    // },
    ...pathnames.map((value, index) => {
      const path = `/${pathnames.slice(0, index + 1).join('/')}`;
      return {
        key: path,
        title: <Link to={path}>{capitalizeFirstLetter(value)}</Link>
      };
    })
  ];
    return (
      // <Breadcrumb style={{ margin: '5px 16px 0 16px' }} items={items} />
       <Breadcrumb style={{ margin: '5px 16px 0 16px' }}  />
    )
}
